import { ChangeEventHandler, FormEventHandler, useState } from 'react'
import styled from 'styled-components'
import { CustomerButton } from '@bm-js/atlascloud-ui'
import CustomerInput from './CustomerInput'
import CustomerTextarea from './CustomerTextarea'
import { DynamicContentType, WebsiteConfigBM } from '@bm-js/atlascloud-shared'
import { ContactFormData } from '@bm-js/atlascloud-shared'

const StyledContactFormContent = styled.div<{ $base: string }>`
  background: white;
  padding: 1rem;
  box-shadow:
    0px 1px 3px rgba(16, 24, 40, 0.1),
    0px 1px 2px rgba(16, 24, 40, 0.06);
  .success-container {
    text-align: center;
  }
  h2 {
    color: ${({ $base }) => $base};
  }
`

type Props = {
  content: DynamicContentType<ContactFormData>
  websiteConfig: WebsiteConfigBM
}

const ContactFormContent = ({ content, websiteConfig }: Props) => {
  const initialFormData = {
    name: '',
    email: '',
    phone: '',
    message: [],
  }
  const [formData, setFormData] = useState(initialFormData)
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const inEditSubmit: FormEventHandler = (e) => {
    e.preventDefault()
    setLoading(true)
    setTimeout(() => {
      if (!content.data.responseEmail) {
        alert(
          'Du har inte fyllt i någon mailadress till vilken formuläret ska skickas.'
        )
      } else {
        alert(
          `Här i hemsideredigeraren går det inte att använda formuläret.\n\nNär formuläret publiceras så kommer kontaktförfrågan att skickas till ${content.data.responseEmail}.`
        )
      }
      setFormData(initialFormData)
      setSuccess(true)
      setLoading(false)
    }, 1000)
  }

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  if (success)
    return (
      <StyledContactFormContent
        $base={websiteConfig.colors.base}
        style={{ marginBottom: content.data.marginBottom }}
      >
        <div className='ptop2 pbottom2 success-container'>
          <h2 className='c m0'>Tack för ditt mail!</h2>
          <p className='c m0'>Vi återkommer till dig så snart vi kan.</p>
          <CustomerButton
            className='mtop05 c'
            onClick={() => setSuccess(false)}
          >
            OK
          </CustomerButton>
        </div>
      </StyledContactFormContent>
    )

  return (
    <StyledContactFormContent
      $base={websiteConfig.colors.base}
      style={{ marginBottom: content.data.marginBottom }}
    >
      <form onSubmit={inEditSubmit}>
        {content.data.header && (
          <h2 className='m0 mbottom05'>{content.data.header}</h2>
        )}
        {content.data.instruction && (
          <p className='m0 mbottom1'>{content.data.instruction}</p>
        )}
        <CustomerInput
          required
          type='text'
          label={'Namn'}
          desc={'För- och efternamn'}
          name='name'
          id='name'
          value={formData.name}
          onChange={handleChange}
        />
        <CustomerInput
          required
          type='email'
          label={'Mailadress'}
          desc={'Ett bekräftelsemail skickas till denna mailadress'}
          name='email'
          id='email'
          value={formData.email}
          onChange={handleChange}
        />
        <CustomerInput
          type='tel'
          label={'Telefonnummer'}
          desc={'Frivilligt fält'}
          name='phone'
          id='phone'
          value={formData.phone}
          onChange={handleChange}
        />
        <CustomerTextarea
          h={12}
          label={'Ditt meddelande'}
          name='message'
          id='message'
          value={formData.message.join('\n')}
          onChange={(e) =>
            setFormData({
              ...formData,
              [e.target.name]: e.target.value.split('\n'),
            })
          }
        />
        <div className='ac jce flex'>
          <CustomerButton type='submit' disabled={loading}>
            {loading ? 'Skickar...' : 'Skicka'}
          </CustomerButton>
        </div>
      </form>
    </StyledContactFormContent>
  )
}

export default ContactFormContent
